module.exports = require("babel-polyfill");


//////////////////
// WEBPACK FOOTER
// external "babel-polyfill"
// module id = 5
// module chunks = 0